import * as Sentry from "@sentry/nextjs";
import { redactBrowserSentryEvent } from "./sentry-redaction";

let initialized = false;

export function initSentryBrowser(): void {
  if (initialized || typeof window === "undefined") {
    return;
  }

  const dsn = process.env["NEXT_PUBLIC_SENTRY_DSN"];
  if (!dsn) {
    return;
  }

  const isProd = process.env["NODE_ENV"] === "production";

  Sentry.init({
    dsn,
    environment: process.env["NODE_ENV"] ?? "development",
    release: process.env["NEXT_PUBLIC_GIT_SHA"] ?? "dev",
    tracesSampleRate: isProd ? 0.1 : 1.0,
    beforeSend(event) {
      return redactBrowserSentryEvent(event);
    },
    beforeSendTransaction(event) {
      return redactBrowserSentryEvent(event);
    },
  });

  initialized = true;
}
